import React from 'react';
import Navbar from './Navbar';
import SettingsMenu from './SettingsMenu';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <div className="flex">
        <SettingsMenu />
        <main className="flex-1 bg-gray-100">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout; 